module.exports = __webpack_public_path__ + "static/media/TP12.43d41c4c.jpg";